
import type { Camera, CameraGroup } from '@/api';
import { CamerasFilter } from '@/api/models/CamerasFilter';
import { ListViewModel } from '@/definitions/view-models/list.view.model';
import { Options, Prop, Vue, Watch } from 'vue-property-decorator';
import VideoWallCameraListGroupHeader from './VideoWallCameraListGroupHeader.vue';
import VideoWallCameraListGroupItem from './VideoWallCameraListGroupItem.vue';
import { viewModelRepository } from '@/api/common';
import { NLoadingCircle, NLoadingDots } from '@/uikit';

@Options({
  components: {
    VideoWallCameraListGroupHeader,
    VideoWallCameraListGroupItem,
    NLoadingDots
  }
})
export default class VideoWallCameraListGroup extends Vue {
  @Prop({ required: true, type: Object })
  readonly group!: CameraGroup;

  expanded: boolean = false;  
  module: ListViewModel<Camera, CamerasFilter> = viewModelRepository.getCamerasListViewModel();

  mounted(): void {
      this.module.filter.current.camera_groups = [this.group.id];
      this.module.filter.current.limit = '100';
  }
  
  get cameras(): Camera[] {
    return this.module?.items || [];
  }

  @Watch('expanded')
  expandedChanged(v: boolean) {
    if (v && !this.module.loaded) {
      this.module?.get();
    }
  }
}
